export default __webpack_public_path__ + "asset/img/icon-goods-video~9e504a5d.png";